module.exports = "../images/byob-package@2x.jpg?v=43eced6";